<script setup lang="ts">
import { watch, computed } from 'vue'
import { useRefiner } from '@crv/vue-3-components'
import { i18n } from '@/i18n/entry'
import { useDisplay } from 'vuetify'
import router from '@/router'
import packageJson from '@/../package.json'

  const { smAndUp } = useDisplay()

  
  const { setLocale, showRefinerForm } = useRefiner({
    projectId: process.env.VUE_APP_REFINER_GENERAL_PROJECT_ID,
    locale:  i18n.global.locale
  })
  
  watch(() => i18n.global.locale, (newLocale) => {
    setLocale(newLocale)
  })
    
  const onClickFeedback = () => {
    showRefinerForm({
      formId: process.env.VUE_APP_REFINER_GENERAL_FORM_ID,
      appVersion: packageJson.version,
      route: router.currentRoute.value.fullPath,
      isMobile: (!smAndUp.value).toString(),
    })
  }

  const refinerClass = computed(() => smAndUp.value ? 'desktop' : 'mobile')
</script>


<template>
  <v-btn
    class="refiner_button"
    color="primary"
    :class="refinerClass"
    @click="onClickFeedback"
  >
    Feedback
  </v-btn>
</template>
  

<style scoped lang="scss">
  .refiner_button {
    width: fit-content;
  
    &.mobile {
      margin: 0 auto;
    }
  
    &.desktop {
      position: fixed;
      bottom: 0;
      right: 15px;
    }
  }

</style>
  